import { HttpError } from "react-admin";

import { type ApiError } from "@/api";
import { HTTP_STATUS } from "@/constants";

import { assertAllFieldsDefined } from "./types";

export const throwApiHttpErrorMessage = (error: unknown): never => {
  const typedError = error as ApiError | undefined;
  const title = typedError?.title ? `${typedError.title}: ` : "";
  const detail =
    typedError?.detail || typedError?.message || "Something went wrong";
  const status =
    typedError?.status || typedError?.code || HTTP_STATUS.INTERNAL_SERVER_ERROR;

  throw new HttpError(`${title}${detail}`, status);
};

export const getRequiredFieldsErrorMessage = (
  fields: Record<string, unknown>,
  requiredFields: string[] = [],
) => {
  const missingFields = requiredFields.filter(
    (field) =>
      fields[field] === undefined ||
      fields[field] === null ||
      fields[field] === "",
  );

  return missingFields.length > 0
    ? `The following fields are required: ${missingFields.join(", ")}`
    : "";
};

export const checkAndThrowRequiredFieldsError = <
  T extends Record<string, unknown>,
>(
  fields: Partial<T>,
  requiredFields: string[] = [],
) => {
  const errorMessage = getRequiredFieldsErrorMessage(fields, requiredFields);
  if (errorMessage) {
    throw new HttpError(errorMessage, HTTP_STATUS.INTERNAL_SERVER_ERROR);
  }
  return assertAllFieldsDefined(fields);
};
